import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopbarComponent } from './topbar.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ModalModule } from '../../modal/modal.module';
import { ButtonFillModule } from 'src/app/common/utilities/buttons/button-fill/button-fill/button-fill.module';
import { ButtonOutlineModule } from 'src/app/common/utilities/buttons/button-outline/button-outline/button-outline.module';


@NgModule({
  declarations: [
    TopbarComponent
  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    ModalModule,
    ButtonFillModule,
    ButtonOutlineModule
  ],
  exports: [
    TopbarComponent
   ]
})
export class TopbarModule { }
